import { LoginUsecase, RefreshTokenUseCase } from './account';
import { GetCommittedOrdersUsecase } from './committed-orders';
import {
  GetSampleJLUploadFilesUseCase,
  GetSampleLocationFilesUsecase,
  GetSampleNetworkFilesUsecase,
} from './configuration';
import { GetDistributionAreasUsecase } from './distribution-areas';
import { GetDistributionLanesUsecase } from './distribution-lanes';
import { GetGeoCoordinatesUsecase } from './geo-coordinates';
import {
  GetGridHeadersUsecase,
  UpdateGridHeadersUsecase,
} from './grid-headers';
import {
  AddJobUsecase,
  BatchInjectLocationJobUsecase,
  CalculateJobETAUsecase,
  DeleteJobUsecase,
  GetJobDetailsUsecase,
  GetJobFiltersUsecase,
  GetJobTemplateUsecase,
  GetJobsUsecase,
  GetLocationsToAddInJobUsecase,
  GetPlanJobsUsecase,
  GetHDPlanJobsUsecase,
  InjectLocationJobUsecase,
  OptimizeJobUsecase,
  PrintJobUsecase,
  UpdateJobUsecase,
  ValidateJobTerminalsAndLocationUsecase,
  ValidateNewJobTerminalsAndLocationUsecase,
  CalculateHDPlanJobETAUsecase,
  GetHDSequenceUsecase,
} from './jobs';
import {
  GetPublicLocationsByJobIdUsecase,
  GetPublicLocationsBySegmentIdUsecase,
  GetUnAssignedPublicLocationsByJobIdUsecase,
  UpdatePublicLocationSequence,
} from './public-location';
import {
  BulkUpdateLocationUsecase,
  DeleteAllUnAssignedLocationUsecase,
  DeleteUnassignedLocationsUsecase,
  EditLocationCalculateJobETAUsecase,
  EditLocationUsecase,
  GetLocationByIdUsecase,
  GetLocationTagsMlsUsecase,
  GetLocationsByPlanIdUsecase,
  GetLocationsBySegmentIdUsecase,
  GetLocationsUpdateNotificationUsecae,
  GetLocationsUsecase,
  GetLookupLocationsByJobIdUsecase,
  GetPlanAndJobsLocationsUsecase,
  GetUnAssignedLocationsUsecase,
  ImportPlanLocationsCSVUsecase,
  RemoveLocationUsecase,
  RemoveOrUnassignedLocationsUsecase,
  UnassignLocationUsecase,
  UpdateLocationDetailsUsecase,
  UpdateLocationFromMlsUsecase,
  UpdatePlanLocationUsecase,
} from './locations';
import {
  GetLookupJobUsecase,
  GetLookupLocationsUsecase,
  GetLookupMasterPlansUsecase,
  GetLookupPlansUsecase,
} from './lookups';
import { GetMapProviderUsecase } from './map-provider';
import {
  AddManualLocationUsecase,
  DeleteMasterLocationUseCase,
  GetActivitiesByProductUsecase,
  GetPostalCodesUsecase,
  GetLocationImportUsecase,
  GetLocationTypeUseCase,
  GetPrivateLocationDetailUsecase,
  GetPublicLocationsForAutoCompleteUsecase,
  GetPublicLocationsUsecase,
  GetSegmentIdUsecase,
  GetTagsUsecase,
  ImportPlanContainerLocationCSVUsecase,
  GetFiltersUsecase
} from './master-location';
import {
  GetLocationGroupsByMasterPlanIDUsecase,
  DeleteLocationGroupUsecase,
  CreateLocationsGroupsByAMSUseCase,
  CreateLocationGroupUseCase,
  EditLocationGroupUsecase,
  GetLocationsGroupByIdUsecase,
} from './location-group';

import {
  AddMasterPlanLocationUsecase,
  AddMasterPlanUsecase,
  CommitPlanUsecase,
  DeleteMasterPlanUsecase,
  EditMasterPlanLocationUsecase,
  EditMasterPlanUsecase,
  GetLocationCountByProductUseCase,
  GetLocationCountUseCase,
  GetMasterLocationByIdUsecase,
  GetMasterPlanLocationUseCase,
  GetMasterPlansUsecase,
  GetMasterPlanTypesUseCase,
  GetPlanContainerByIdUseCase,
  GetPlanContainerByPlanIdUseCase,
  GetPlanContainerLocationUseCase,
  GetTimeZonesUseCase,
} from './master-plans';
import { GetMasterPlanLocationDetailsByIdUseCase } from './master-plans/get-master-plan-location-details-by-id-usecase';
import { GetPlanTypeUsecase } from './plan-type';
import {
  AddPlanUsecase,
  AddPlanWithJobUsecase,
  AddPlanWithLocationUsecase,
  AttachSchedulerUsecase,
  BindLocationWithMultiplePlansJobUsecase,
  CalculatePlanETAUsecase,
  CalculateHDPlanETAUsecase,
  ClonePlanUsecase,
  DeletePlanUsecase,
  EditPlanUsecase,
  AssignLocationsGroupsToPlanUsecase,
  EditPlanWithJobUsecase,
  ExportPlanCSVUsecase,
  ExportPlanToCSVUsecase,
  GenerateRouteUsecase,
  GetPlanByIdUsecase,
  GetPlanJobDetailsUsecase,
  GetPlansUsecase,
  GetSchedulerUsecase,
  ImportJobsCSVUseCase,
  ImportPlanCSVUsecase,
  ImportPlanUsecase,
  InjectPlanLocationsUsecase,
  OptimizePlanUsecase,
  PlanRevisionUsecase,
  RemovePlanSchedulerUsecase,
  UnCommitPlanUsecase,
  ValidateJLCsvFileUseCase,
} from './plans';
import { GetProductsUsecase } from './product-portal';
import {
  CreateSchedulerInstanceUseCase,
  GetPlansScheduledUseCase,
  RemoveSchedulerInstanceUseCase,
  UpdateSchedulerInstanceUseCase,
} from './scheduler';
import {
  AddEditTransportServiceUsecase,
  AddOtherDistributorsServiceUsecase,
  AddServiceUsecase,
  DeleteServiceUsecase,
  EditServiceUsecase,
  GetServicesUsecase,
} from './services';
import { GetTenantByIdUsecase, GetFeatureConfigurationUsecase } from './tenant';
import { GetvehicleGroupUsecase } from './vehicle-group/get-vehicle-group-usecase';
import { UpdateVehicleGroupUsecase } from './vehicle-group/update-vehicle-group-usecase';
import { GetWeekdayUsecase } from './week-days';
import {
  CreatePlanRulesTemplateUsecase,
  EditPlanRulesTemplateUsecase,
  GetPlanRulesTemplateByPlanIdUsecase,
} from './plan-rules-template';
import { GetUserRulesTemplatesUsecase } from './user-rules-template/get-user-rules-templates-usecase';
import { DeleteUserRulesTemplateUsecase } from './user-rules-template/delete-user-rules-template-usecase';
import { CreateUserRulesTemplateUsecase } from './user-rules-template/create-user-rules-template-usecase';
import { EditUserRulesTemplateUsecase } from './user-rules-template/edit-user-rules-template-usecase';
import { GetUserRulesTemplateByIdUsecase } from './user-rules-template/get-user-rules-template-by-id-usecase';
import { GetUserRulesTemplatesIncludingDefaultUsecase } from './user-rules-template/get-user-rules-template-including-default-usecase';
import { UpdateLocationGroupByIdUsecase } from './location-group/update-location-group-usecase';
import { UpdateHdJobUsecase } from './jobs/update-hd-job-usecase';
import { GetVehicleTypesUsecase } from './vehicle-group/get-vehicle-types-usecase';

export * from './account';
export * from './committed-orders';
export * from './configuration';
export * from './distribution-areas';
export * from './distribution-lanes';
export * from './geo-coordinates';
export * from './grid-headers';
export * from './jobs';
export * from './locations';
export * from './lookups';
export * from './map-provider';
export * from './master-location';
export * from './master-plans';
export * from './plan-type';
export * from './plans';
export * from './product-portal';
export * from './scheduler';
export * from './services';
export * from './tenant';
export * from './vehicle-group';
export * from './location-group';
export * from './week-days';
export * from './plan-rules-template';
export * from './user-rules-template';
export const provideUsecases = () => {
  return [
    //account
    LoginUsecase,
    RefreshTokenUseCase,
    GetMapProviderUsecase,
    //CommittedOrder
    GetCommittedOrdersUsecase,
    GetSegmentIdUsecase,
    //DistributionLans
    GetDistributionLanesUsecase,
    //MasterPlan
    GetMasterPlansUsecase,
    AddMasterPlanUsecase,
    GetLocationImportUsecase,
    EditMasterPlanUsecase,
    GetPlanContainerLocationUseCase,
    CommitPlanUsecase,
    DeleteMasterPlanUsecase,
    AddMasterPlanLocationUsecase,
    GetMasterPlanLocationUseCase,
    GetLocationCountUseCase,
    GetLocationCountByProductUseCase,
    GetPlanContainerByIdUseCase,
    GetMasterLocationByIdUsecase,
    EditMasterPlanLocationUsecase,
    GetPublicLocationsForAutoCompleteUsecase,
    GetPrivateLocationDetailUsecase,
    GetPlanContainerByPlanIdUseCase,
    UpdateLocationDetailsUsecase,
    GetMasterPlanTypesUseCase,
    //Plan
    GetSchedulerUsecase,
    GetPlansUsecase,
    AddPlanUsecase,
    EditPlanUsecase,
    AssignLocationsGroupsToPlanUsecase,
    DeletePlanUsecase,
    ClonePlanUsecase,
    GetPlanTypeUsecase,
    OptimizePlanUsecase,
    AddPlanWithJobUsecase,
    EditPlanWithJobUsecase,
    AddPlanWithLocationUsecase,
    RemovePlanSchedulerUsecase,
    UnCommitPlanUsecase,
    PlanRevisionUsecase,
    ImportPlanUsecase,
    ImportPlanCSVUsecase,
    ExportPlanCSVUsecase,
    ExportPlanToCSVUsecase,
    InjectPlanLocationsUsecase,
    BatchInjectLocationJobUsecase,
    GetTimeZonesUseCase,
    GetWeekdayUsecase,
    GenerateRouteUsecase,
    // GetAllPlanJobsUsecase,
    CalculatePlanETAUsecase,
    CalculateHDPlanETAUsecase,
    AttachSchedulerUsecase,
    BindLocationWithMultiplePlansJobUsecase,
    GetPlanJobDetailsUsecase,
    GetPlanByIdUsecase,
    //Job
    UpdateHdJobUsecase,
    GetJobsUsecase,
    AddJobUsecase,
    UpdateJobUsecase,
    DeleteJobUsecase,
    GetGeoCoordinatesUsecase,
    GetJobDetailsUsecase,
    OptimizeJobUsecase,
    GetJobFiltersUsecase,
    CalculateJobETAUsecase,
    GetHDSequenceUsecase,
    GetLocationsToAddInJobUsecase,
    PrintJobUsecase,
    GetJobTemplateUsecase,
    ValidateJobTerminalsAndLocationUsecase,
    ValidateNewJobTerminalsAndLocationUsecase,
    ValidateJLCsvFileUseCase,
    ImportJobsCSVUseCase,
    CalculateHDPlanJobETAUsecase,
    //public location
    GetUnAssignedPublicLocationsByJobIdUsecase,
    GetPublicLocationsBySegmentIdUsecase,
    GetPublicLocationsByJobIdUsecase,
    UpdatePublicLocationSequence,
    //Location
    UnassignLocationUsecase,
    GetLookupLocationsByJobIdUsecase,
    GetLocationsUsecase,
    EditLocationUsecase,
    BulkUpdateLocationUsecase,
    GetLocationByIdUsecase,
    GetPlanAndJobsLocationsUsecase,
    UpdatePlanLocationUsecase,
    EditLocationCalculateJobETAUsecase,
    GetLocationsByPlanIdUsecase,
    GetUnAssignedLocationsUsecase,
    GetLocationsBySegmentIdUsecase,
    RemoveLocationUsecase,
    ImportPlanLocationsCSVUsecase,
    DeleteAllUnAssignedLocationUsecase,
    RemoveOrUnassignedLocationsUsecase,
    GetLocationTagsMlsUsecase,
    AddManualLocationUsecase,
    GetLocationTypeUseCase,
    GetActivitiesByProductUsecase,
    GetLocationsUpdateNotificationUsecae,
    UpdateLocationFromMlsUsecase,
    //Services
    GetServicesUsecase,
    AddServiceUsecase,
    EditServiceUsecase,
    DeleteServiceUsecase,
    AddEditTransportServiceUsecase,
    AddOtherDistributorsServiceUsecase,
    //Product Portal
    GetProductsUsecase,
    //MasterLocation
    GetPostalCodesUsecase,
    GetTagsUsecase,
    GetPublicLocationsUsecase,
    GetSegmentIdUsecase,
    ImportPlanContainerLocationCSVUsecase,
    GetMasterPlanLocationDetailsByIdUseCase,
    DeleteMasterLocationUseCase,
    GetFiltersUsecase,
    //Location Group
    GetLocationGroupsByMasterPlanIDUsecase,
    CreateLocationGroupUseCase,
    CreateLocationsGroupsByAMSUseCase,
    EditLocationGroupUsecase,
    DeleteLocationGroupUsecase,
    GetLocationsGroupByIdUsecase,
    UpdateLocationGroupByIdUsecase,
    // Grid Headers
    GetGridHeadersUsecase,
    UpdateGridHeadersUsecase,
    GetSampleNetworkFilesUsecase,
    GetSampleJLUploadFilesUseCase,
    GetSampleLocationFilesUsecase,
    // Lookups
    GetLookupLocationsUsecase,
    GetLookupPlansUsecase,
    GetLookupMasterPlansUsecase,
    GetLookupJobUsecase,
    // GeoCoordinates
    GetGeoCoordinatesUsecase,
    InjectLocationJobUsecase,
    GetPlanJobsUsecase,
    GetHDPlanJobsUsecase,
    GetDistributionAreasUsecase,
    //Tenant
    GetTenantByIdUsecase,
    GetFeatureConfigurationUsecase,
    DeleteUnassignedLocationsUsecase,
    //Scheduler
    GetPlansScheduledUseCase,
    UpdateSchedulerInstanceUseCase,
    CreateSchedulerInstanceUseCase,
    RemoveSchedulerInstanceUseCase,
    //vehicle group
    GetvehicleGroupUsecase,
    UpdateVehicleGroupUsecase,
    GetVehicleTypesUsecase,
    //Plan Rules Template
    CreatePlanRulesTemplateUsecase,
    EditPlanRulesTemplateUsecase,
    GetPlanRulesTemplateByPlanIdUsecase,
    //User Rules Template
    GetUserRulesTemplatesUsecase,
    DeleteUserRulesTemplateUsecase,
    CreateUserRulesTemplateUsecase,
    EditUserRulesTemplateUsecase,
    GetUserRulesTemplateByIdUsecase,
    GetUserRulesTemplatesIncludingDefaultUsecase,
  ];
};
